import { db } from '@/main'
import helpers from '@/helpers.js'
import { formatDistance } from 'date-fns'
import { cloneDeep } from "lodash"
import { 
  doc,
  setDoc,
  getDoc,
  deleteDoc
} from "firebase/firestore";

export default {
  name: "resource",
  components: {},
  props: [],
  data() {
    return {
      view: {
        loadingResource: true,
        editState: "off",
        saving: false,
        error: null,
        confirmDelete: false,
      },
      resourceEditMode: null,
      tagInput: "",
    };
  },
  computed: {
    user() {
      return this.$store.getters.userData;
    },
    org() {
      return this.$store.getters.activeOrg;
    },
    resourceDirectory() {
      return this.$store.state.resources.boundDirectory;
    },
    resource() {
      return this.$store.getters.resource(this.$route.params.resource);
    },
    resourceTags () {
      return this.$store.getters.resourcesTags
    }
  },
  mounted() {
    console.log("resource mounted, resource:", this.resource);
    if (!this.resource || !this.resource.loadedData) {
      this.$store.dispatch("fetchDocData", {
        id: this.$route.params.resource,
        collection: "resources",
      });
    }
  },
  watch: {
    resource () {
      // update page name if we get the data
      if(this.resource && this.resource.name){
        this.$route.meta.title = this.resource.name;
      }
    }
  },
  methods: {
    getTimeWords(time) {
      let res = formatDistance(new Date(time), new Date(), { addSuffix: true });
      return res;
    },
    async updateResource(archive) {
      console.log("updating resource");

      this.view.saving = true;

      console.log("this.resourceEditMode:", this.resourceEditMode);

      let resourceData;
      if (!archive) {
        resourceData = cloneDeep(this.resourceEditMode);
      } else {
        resourceData = cloneDeep(this.resource);
        resourceData.archived = true;
        console.log("User is archiving resource");
      }

      resourceData.orgLink = this.org.id;
      resourceData.updater = this.user.id;

      let resourceObj = new helpers.Resource(resourceData);

      console.log("resourceObj:", resourceObj);

      try {
        await setDoc(
          doc(
            db,
            "orgs",
            this.org.id,
            "resources",
            resourceObj.id
          ).withConverter(helpers.resourceConverter),
          resourceObj,
          {
            merge: true,
          }
        );

        this.$router.replace(
          "?u=" + Math.floor(Math.random() * (999 - 100 + 1) + 100)
        );

        this.$route.meta.title = resourceObj.name;

        await this.$store.dispatch("updateDoc", {
          data: resourceObj,
          action: archive ? "delete" : "update",
          docType: "resources",
          fullDoc: true
        });

        if (!archive) {
          this.$router.replace(
            "?u=" + Math.floor(Math.random() * (999 - 100 + 1) + 100)
          );
        } else {
          this.$router.push(`/${this.org.name}/resources`);
        }

        this.$toast.success(this.$t("toast-Success"));
      } catch (error) {
        console.log("err updating resource:", error);
        this.$toast.error(`${this.$t("toast-Error")}: ${error}`);
      } finally {
        this.view.saving = false;
        this.view.editState = "off";
      }
    },
    async onImageUploadSuccess(res) {
      console.log("image upload success:", res);

      this.resourceEditMode.image = res.filePath;
    },
    onImageUploadError(err) {
      console.log("err:", err);
      this.$toast.error(`Something went wrong`);
    },
    initImageUpload() {
      console.log("init image change");
      this.view.userSelectingImage = true;
      this.$refs.imageUploader.childNodes[0].click();
    },
    tagInputChange(e) {
      if (e.inputType !== "insertText") {
        return;
      }

      // if it doesn't have data, it was not a keypress, was enter or mouse click
      if (!e.data) {
        this.addTag();
      }

      if (this.tagInput.indexOf(",") > 0) {
        this.addTag();
      }
    },
    addTag() {
      let tags = this.tagInput.split(",");
      tags.forEach((tag) => {
        console.log("tag:", tag);
        if (tag.length) {
          this.resourceEditMode.tags.push(tag.toLowerCase());
        }
      });
      this.tagInput = "";
    },
    removeTag(tag) {
      console.log("remove tag:", tag);
      let newTags = this.resourceEditMode.tags.filter((existingTag) => {
        return existingTag !== tag;
      });
      console.log("tags now:", newTags);
      this.resourceEditMode.tags = newTags;
    },
    editResource() {
      this.view.editState = "editing";
      this.resourceEditMode = cloneDeep(this.resource);
    },
    cancelEditing() {
      this.view.editState = "off";
    },
  },
};
